/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         SYMBOLS = "symbols"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class GameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO:string = "introLogo";

    public static NORMAL_REEL_DIVIDER:string = "reelDivider";
    public static NEAR_WIN_REEL_DIVIDER:string = "reelDividerNearWin";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";

    public static WIN_FRAMES:string = "Win_Frames/Frame_";

    public static IN_GAME_ARROW:string = "resources/images/in_game_arrow.png";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("NumbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            }
        ],
        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ],
                animations : {
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "button" : "ui/gameTweakerButton/button",
                    "button-disabled" : "ui/gameTweakerButton/button-disabled",
                    "IdleReelBg" : "SymWinFX/SymWinFX_",
                    "winReelBg" : "SymWinFX_Initial/SymWinFX_Initial_",
                    "Wild_Expand4" : "W_4to7/W_4to7_",
                    "Wild_Expand7" : "W_7to10/W_7to10_",
                    "M_Reveal4" : "FX_Burn/M4/M4_Burn_",
                    "M_Reveal5" : "FX_Burn/M5/M5_Burn_",
                    "M_Reveal6" : "FX_Burn/M6/M6_Burn_",
                    "M_Reveal7" : "FX_Burn/M7/M7_Burn_",
                    "WildTranform" : "W_Transform/W_Transform_",
                    
                    "Poo" : "Dead/Dead_Poo",
                    "Finger" : "Dead/Dead_Finger",
                    "Blixt" : "Dead/Dead_Blixt",
                    "Spray" : "Dead/Dead_Spray"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json")
                ],
                animations : {
                    "mainBackground" : "mainBackground",
                    "SymLandingFX" : "SymLandingFX/SymLandingFX_",
                    "FX_HotZone_Win" : "FX_HotZone_Win/FX_HZ_Win_",
                    "Wild_Win4" : "W_Win_4/W_win_4_",
                    "Wild_Win7" : "W_Win_7/W_win_7_",
                    "Wild_Win10" : "W_Win_10/W_win_10_",
                    "S_to_W" : "S_to_W/S_to_W_",
                    "S_Attention" : "S_Attention/S_Attention_",
                    "S_Attention_1" : "S_Attention_1/S_Attention_1_",
                    "ExpandingFrame" : "FX_FireNrg/FX_FireNrg_",
                    "ScatterFire" : "FX_S_Fire/FX_S_Fire_",
                    "RowDivider" : "FX_Divider/Divider_",
                    "WildExpand3" : "W_Expand_3x3/W_Expand3x3_",
                    "WildExpand6" : "W_Expand_6x6/W_Expand6x6_",
                    "Shatter" : "FX_Win_Shatter/WinShatter_",
                    "BigWinFire" : "FX_BW_Fire/BW_Fire_",
                    "WildLand" : "W_Landing/W_Landing_",
                    "WildFire" : "FX_W_Fire/FX_W_Fire_",
                    "WildIgnite" : "FX_W_Ignition/FX_Ignition_",
                    "WildIdle" : "FX_W_Ignition_Idle/FX_Ignition_Idle_",
                    "WildFireSpin" : "FX_W_Fire_Loop/FX_W_Loop_",
                    "Spark" : "FX_B_Spark_Loop/FX_B_Loop_",
                    "JumpWildDark" : "Jumping_Wild/W_Jumping_Dis",
                    "JumpFire": "FX_Jumping_Fire/Jumping_Fire_",
                    "Reel6Idle" : "FX_Reel_6_Idle/Reel_6_Idle_",
                    "Reel_Electric" : "FX_Jumping_Electric/FX_Electric_",
                    "Attention_sector" : "FX_Jumping_attention_sector/Attention_Sector_"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("Retrigger", "spine/Retrigger.json"),
                    new SpineAsset("JWild", "spine/Jumping_Wild.json"),
                    new SpineAsset("reel6Boom", "spine/Reel_6_Bending.json"),
                    new SpineAsset("Header", "spine/Header_Loop.json"),
                    new SpineAsset("Police", "spine/Police_FS.json"),
                    new SpineAsset("crack", "spine/FX_Shatter.json"),
                    new SpineAsset("Poster_Riot", "spine/Screen_Riot.json"),
                    new SpineAsset("Poster_Anarchy", "spine/Screen_Anarchy.json"),
                    new SpineAsset("Poster_Civil_War", "spine/Screen_Civil_War.json"),
                    new SpineAsset("Poster_Bigwin", "spine/Big_Win.json"),
                    new SpineAsset("Poster_Superwin", "spine/Mega_Win.json"),
                    new SpineAsset("Poster_Epicwin", "spine/Super_Mega_Win.json"),
                    new SpineAsset("Poster_Wickedwin", "spine/Epic_Win.json"),
                    new SpineAsset("No_Win", "spine/No_Win.json"),
                    new SpineAsset("superX1", "spine/Xpand_M1_7.json"),
                    new SpineAsset("superX2", "spine/Xpand_M2_7.json"),
                    new SpineAsset("superX3", "spine/Xpand_M3_7.json"),
                    new SpineAsset("superX4", "spine/Xpand_M4_7.json"),
                    new SpineAsset("superX5", "spine/Xpand_M5_7.json"),

                    new SpineAsset("fog", "spine/Idle_Fog.json"),
                ]
            },
            {
                name : "symbols",
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            }
        ]
    };

}
